import React from "react";

interface EnvironmentBannerProps {
  env: string;
}

const EnvironmentBanner: React.FC<EnvironmentBannerProps> = ({ env }) => {
  if (env === "production") return null;

  const label = env === "development" ? "DEV" : env.toUpperCase();

  return (
    <div className="fixed top-2 right-2 z-50 rounded bg-green-200 px-2 py-1 text-xs font-medium text-green-800 shadow-sm">
      {label}
    </div>
  );
};

export default EnvironmentBanner;
